import o from "../../../temp-lib/hooks/web3/useWeb3.js";
import { formatNumberString as a } from "../../../temp-lib/util/misc/formatNumberString.js";
const m = () => {
  const { fromWei: e } = o();
  return {
    getDisplayBalance: (t, r) => {
      const s = e(String(t), r);
      return a(s, {});
    }
  };
};
export {
  m as default
};
//# sourceMappingURL=useAssetHelper.js.map
